import React, { useMemo, useState } from 'react'
import { Modal, Button, Input } from 'antd'
import LinkWithIcon from "../../../../cleanui/InfoLink";
import bookOpen from "../../../HcManager/Analytics/subcomponents/book-open.svg";

const CreateSubdomainDialog = ({
  error,
  open,
  title,
  loading,
  handleCreateSubdomain,
  handleCloseDialog,
}) => {
  const [url, setUrl] = useState('')

  const renderContent = useMemo(() => {
    return (
      <div className="d-flex flex-column">
        <span>Enter your Help Center URL</span>
        <div className="mt-2">
          <Input
            value={url}
            onChange={(event) => {
              setUrl(event.target.value)
            }}
          />
        </div>
        {error && (
          <div className="mt-2 text-danger">
            <span>
              Unable to add this Help Center. Change the URL or{' '}
              <a
                style={{ cursor: 'pointer' }}
                className={'text-primary'}
                href="mailto:support@swifteq.com"
              >
                contact us
              </a>
              .
            </span>
          </div>
        )}
      </div>
    )
  }, [error, url])

  const renderDialog = useMemo(() => {
    return (
      <Modal
        open={open}
        title={<div className="d-flex">
          {title}
          <div className="ml-5"><LinkWithIcon
            link={"https://support.swifteq.com/hc/en-us/articles/21959819876881-Connecting-and-Selecting-Additional-Help-Centers"}
            text={"How to add a Help Center"}
            openInNewTab={true}
            icon={bookOpen}
          />
          </div>
        </div>}
        onOk={() => handleCreateSubdomain && handleCreateSubdomain({ url })}
        onCancel={() => handleCloseDialog && handleCloseDialog()}
        footer={[
          <Button
            type="primary"
            loading={loading}
            key="add"
            onClick={() => handleCreateSubdomain && handleCreateSubdomain({ value: url })}
          >
            Add
          </Button>,
          <Button key="back" onClick={() => handleCloseDialog && handleCloseDialog()}>
            Cancel
          </Button>,
        ]}
      >
        <div className="d-flex flex-column">{renderContent}</div>
      </Modal>
    )
  }, [open, error, title, handleCreateSubdomain, handleCloseDialog, url, renderContent, loading])

  return <>{renderDialog}</>
}

export default CreateSubdomainDialog
